export default __webpack_public_path__ + "static/media/ultra3.4a4bb075.png";